import { Link, NavLink } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { NETWORKS, SITE } from "@/data/networks";

const navCls = ({ isActive }) =>
  `px-3 py-1.5 rounded-full text-sm transition-colors duration-300 ${
    isActive ? "bg-[#1F1A17] text-[#FBF8F4]" : "text-[#685F58] hover:text-[#1F1A17]"
  }`;

export const Header = () => (
  <header className="sticky top-0 z-50 backdrop-blur-md bg-[#FBF8F4]/80 border-b border-[#E8DDD3]/80">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 sm:h-[72px] flex items-center justify-between gap-4">
      <Link to="/" data-testid="header-logo-link" aria-label="Hearthside home"><Logo /></Link>
      <nav className="hidden lg:flex items-center gap-1" data-testid="header-nav">
        <NavLink to="/" end className={navCls} data-testid="nav-hub">All channels</NavLink>
        {NETWORKS.map((n) => (
          <NavLink key={n.key} to={`/${n.key}`} className={navCls} data-testid={`nav-${n.key}`}>{n.name}</NavLink>
        ))}
      </nav>
      <a
        href={`${SITE}/?utm_source=hearthside&utm_medium=social&utm_campaign=hearthside`}
        data-testid="header-visit-site-btn"
        className="group inline-flex items-center gap-1.5 rounded-full bg-[#B4532A] hover:bg-[#9C421E] text-[#FBF8F4] text-sm font-medium h-10 px-4 sm:px-5 transition-colors duration-300"
      >
        <span className="hidden sm:inline">Visit hearthvault.family</span>
        <span className="sm:hidden">Visit site</span>
        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </a>
    </div>
    <nav className="lg:hidden flex gap-1 overflow-x-auto px-5 pb-3 -mt-1 no-scrollbar" data-testid="header-nav-mobile">
      <NavLink to="/" end className={navCls} data-testid="nav-mobile-hub">All</NavLink>
      {NETWORKS.map((n) => (
        <NavLink key={n.key} to={`/${n.key}`} className={navCls} data-testid={`nav-mobile-${n.key}`}>{n.name}</NavLink>
      ))}
    </nav>
  </header>
);
